import create from 'zustand'
import { ViewPreferenceType } from '../types'

export type Store = {
  openedViewPreference: ViewPreferenceType | null
  setOpenedViewPreference: (openedViewPreference: ViewPreferenceType) => void
}

const useViewPreferencesStore = create<Store>((set) => ({
  openedViewPreference: null,
  setOpenedViewPreference: (openedViewPreference: ViewPreferenceType) => set({ openedViewPreference }),
}))

export { useViewPreferencesStore }
